module.exports = __webpack_public_path__ + "static/img/pay-android.0b19089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay-android.png
// module id = pRTE
// module chunks = 1